<template>
  <div class="chat__feed__item">
    <a :href="apiUrl + post.url" target="_blank">
      <div class="chat__feed__group-profile">
        <div class="chat__group-profile-img">
          <img
            :src="apiUrl + defaultClientProfileImage"
            alt="portrait img"
          />
        </div>
        <div class="chat__feed__group-profile__content">
          <p>{{defaultClientName}}</p>
          <div class="label"><span>{{ formatRelativeTime(post.date) }}</span></div>
        </div>
      </div>
      <div class="chat__feed__item__content chat__feed__card card bg--surface">
        <div class="chat__feed__card__img">
          <img v-if="post.postMediaUrl != null"
            :src="apiUrl + post.postMediaUrl"
            alt=""
            :class="post.imageAspectRatio"
          />
        </div>
        <div class="chat__feed__card__content">
          <div class="tags-container">

            <div 
              class="tag tag--default "
              v-for="(tag, index) in newsTags"
              :key="index"
              >

              <span>{{ tag }}</span>
            </div>
          </div>

          <div class="flex-direction--row--desktop">
            <div>
              <h2 class="h3">{{post.title}}</h2>
              <p>{{post.content}}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
    <PostComments v-if="!disableNewsLikes" :post="post" :currentUserAlias="currentUserAlias" @update-post="updatePost" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/da";
import PostComments from "./PostComments.vue";
dayjs.extend(relativeTime);
dayjs.locale("da");

export default {
  name: "NewsPost",
  components: {PostComments},
  props: {
    post: {
      type: Object,
      required: true,
    },
    currentUserAlias: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localPostsData: { posts: [] },
      defaultClientProfileImage: "",
      defaultClientName: "",
      apiUrl: process.env.VUE_APP_API_URL,
      disableNewsLikes : false,
    };
  },
  computed: {
    // tagList bevarer tags med komma i navnet; tags (kommasepareret streng) er kun en fallback.
    newsTags() {
      if (Array.isArray(this.post.tagList)) return this.post.tagList;
      return this.post.tags ? this.post.tags.split(',') : [];
    },
  },
  watch: {
    news: {
      handler(newPosts) {
        if (!newPosts) return;
        this.localPostsData.posts = newPosts.posts || [];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    formatRelativeTime(date) {
      // Hvis datoen slutter med 'Z', fjern det for at undgå problemer med dayjs og tidszoner
      date = dayjs(date.replace(/Z$/, ''));


       var showFromNow = dayjs(date).fromNow();
      var showExactDate = dayjs(date).format("DD. MMM YYYY kl. HH.mm");

      date = this.showRelativeTime ? showFromNow : showExactDate; // Skift mellem relativ og præcis tid baseret på dine behov


      return date;
    },
    updatePost(updatedPost) {
      const postIndex = this.localPostsData.posts.findIndex(
        (p) => p.id === updatedPost.id
      );
      if (postIndex !== -1) {
        // Opdater hele post-objektet
        this.localPostsData.posts.splice(postIndex, 1, { ...updatedPost });
        this.$emit("update-post", this.localPostData);
      }
    },
  },
  mounted() {
    const chatwallWrapper = document.querySelector(".chat-wrapper");
    this.disableNewsLikes = chatwallWrapper.dataset.disablenewslikes === "true";
        this.showRelativeTime = chatwallWrapper.dataset.showrelativetime === "true";
    this.defaultClientName = chatwallWrapper.dataset.clientname;
    this.defaultClientProfileImage = chatwallWrapper.dataset.clientprofileimage;
  },
};
</script>
